import { render, staticRenderFns } from "./TopicMembersForm.vue?vue&type=template&id=0b19e3fc&scoped=true&"
import script from "./TopicMembersForm.vue?vue&type=script&lang=js&"
export * from "./TopicMembersForm.vue?vue&type=script&lang=js&"
import style0 from "./TopicMembersForm.vue?vue&type=style&index=0&id=0b19e3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b19e3fc",
  null
  
)

export default component.exports